<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ order_header.order_code }}</b></div>
            <div v-if="order_header.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #8CC63E">คำสั่งซื้อใหม่</b></div>
            <div v-if="order_header.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #fdac39">ดำเนินการจัดสินค้า</b></div>
            <div v-else-if="order_header.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #8cc63e">เสร็จสิ้น</b></div>
            <div v-else-if="order_header.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #eb5c5d">ยกเลิก</b></div>
          </div>
          <div class="grid_sub_half">
            <div v-if="order_header.status === 2">
              <div v-if="order_header.payment_type === 3" class="padding_header" style="color: black"><b>{{
                order_header.track_number }}</b></div>
              <div v-else class="padding_header" style="color: black"><b>หมายเลขแทร็กกิ้ง : </b> <b
                  style="color: black">{{ order_header.track_number }}</b></div>
            </div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b> <span v-if="order_header.tax_invoice !== 0"
                style="color: #8CC63E;">(รับใบกำกับภาษี)</span></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">{{ order_header.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div v-if="order_header.payment_type !== 3" class="ml-1 mr-3">{{ order_header.delivery_address }}</div>
              <div v-else class="ml-1 mr-3">รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_header.telephone !== null" class="ml-1 mr-3">{{ order_header.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div v-if="order_header.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="order_header.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <div v-else-if="order_header.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div>
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <div class="ml-1 mr-3">{{ format_number(order_number) }} บาท</div>
                </div>
                <div class="d-flex mt-2" style="color: #8CC63E;" v-if="order_header.status === 2">
                  <div class="ml-1 mr-3">ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                </div>
                <div class="d-flex mt-2" style="color: #8CC63E;" v-if="order_header.status === 2">
                  <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                  <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                </div>
                <div class="d-flex mt-2" style="color: red;" v-if="order_header.status === 3">
                  <div class="ml-1 mr-3">ยกเลิก : </div>
                  <div class="ml-1 mr-3">{{ order_header.cancel_note }}</div>
                </div>
                <div class="d-flex mt-2" style="color: red;" v-if="order_header.status === 3">
                  <div class="ml-1 mr-3">ผู้ยกเลิก : </div>
                  <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                </div>
                <div class="mt-2 display_pc" v-if="order_header.status !== 3 && order_header.status !== 2">
                  <v-btn elevation="5" @click="image_modal = true"
                    class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                </div>
              </div>
              <div class="mx-auto">
                <v-img v-if="slip_img.slip_picture !== null && slip_img !== ''" class="rounded" height="160" width="160"
                  @click="show_img" max-width="160" :lazy-src="picture_not_found" :src="slip_img.slip_picture"></v-img>
                <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                  :src="picture_not_found"></v-img>
                <!--                <v-img class="rounded" height="120" width="120" max-width="120" :lazy-src="picture_holder" :src="data.img"></v-img>-->
              </div>
              <div class="mt-2 display_mobile" v-if="order_header.status !== 3 && order_header.status !== 2">
                <v-btn elevation="5" @click="image_modal = true"
                  class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider />
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage"
                hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="border_table pa-3">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" v-if="dataDetail.item.product_picture !== null" height="120"
                          width="120" max-width="120" :lazy-src="picture_product"
                          :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" v-else height="120" width="120" max-width="120"
                          :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div>{{ dataDetail.item.product_name }}<br>
                        <b class="primary--text" v-if="dataDetail.item.count_in_warehouse">จำนวนคงเหลือในคลัง : {{
                          dataDetail.item.count_in_warehouse }}</b>
                      </div>
                      <div v-if="dataDetail.item.product_list !== null">
                        <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                          <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                          <br>
                          <small class="pl-5 primary--text" v-if="data.count_in_warehouse"><b>จำนวนคงเหลือในคลัง : {{
                            data.count_in_warehouse }}</b></small>
                        </div>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.qty) }} {{
                      dataDetail.item.unit_name }}</td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td v-if="order_header.delivery_price !== null" class="border_table text-center"><b>{{
                      format_price(order_header.delivery_price) }}</b></td>
                    <td v-else class="border_table text-center"><b>0.00</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <td class="border_table text-center"><b>{{ format_price((total +
                      parseFloat(order_header.delivery_price))) }}</b></td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-card>
          <div class="text-center pa-5 mb-3"
            v-if="order_header.status === 2 && (order_header.payment_type === 1 || order_header.payment_type === 2)">
            <v-btn large elevation="5" @click="print_send_order" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>
            <v-btn v-if="order_header.tax_invoice === 0" large elevation="5" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-grey-bg white--text rounded-pill" disabled>
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn>
            <v-btn v-if="order_header.tax_invoice === 1" large elevation="5"
              @click="print_tax_invoice(order_header.name, order_header.delivery_address)" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn>
          </div>
        </div>
        <!-- Show Picture -->
        <v-dialog v-model="preview_modal" max-width="512">
          <div v-if="loading_img === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="cancel" @submit.prevent="">
                <div class="d-flex justify-space-between">
                  <v-card-title>
                    หลักฐานการชำระเงิน
                  </v-card-title>
                  <v-btn icon class="ma-4" @click="preview_modal = false">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="">
                    <div class="pa-1 mt-2">
                      <v-img v-if="slip_img.slip_picture !== null" class="mx-auto rounded" max-width="360" :lazy-src="picture_not_found" :src="slip_img.slip_picture"></v-img>
                      <v-img v-else class="mx-auto rounded" max-width="360"
                        :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
                    </div>
                    <div class="text-center pt-2" style="color: #8cc63e">ผู้อัพโหลด : {{ slip_img.from }}</div>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
        <v-dialog v-model="tax_invoice_show" max-width="600">
          <v-card>
            <v-form ref="tax_invoice_save" @submit.prevent="tax_invoice_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ข้อมูลลูกค้า</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="tax_invoice_show = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field type="text" color="#86bc3a" label="ชื่อลูกค้า" v-model="data_tax_invoice.name"
                      prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']"
                      hide-details="auto" required outlined>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="ที่อยู่จัดส่ง" v-model="data_tax_invoice.delivery_address"
                      :rules="[v => !!v || 'กรุณากรอกที่อยู่จัดส่ง']" hide-details="auto" required outlined>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13"
                      @keypress="isTaxNumber($event, data_tax_invoice.tax_number)"
                      :rules="[v => !!v || 'กรุณากรอกเลขเสียภาษี']" prepend-inner-icon="mdi-card-account-details-outline"
                      hide-details="auto" v-model="data_tax_invoice.tax_number" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="รหัสสาขา" type="text"
                      @keypress="isNumber($event, order_header.branch)"
                      :rules="[v => !!v || 'กรุณากรอกรหัสสาขา']" hide-details="auto"
                      v-model="order_header.branch" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div class="pa-1 text-center mt-5">
                      <v-btn x-large type="submit" class="grad-success-bg white--text"
                        style="font-size: 18px">ยืนยันข้อมูล</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_price(order_header.total) }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img v-if="slip_img.slip_picture !== null" class="mx-auto rounded" height="300" width="300"
                    max-width="300" :lazy-src="picture_not_found" :src="slip_img.slip_picture"></v-img>
                  <v-img v-else class="mx-auto rounded" height="300" width="300" max-width="300"
                    :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail(order_header.slip_status)"
                    class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct"
                    class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_not_found from "@/assets/image-not-found.png";
import picture_product from "@/assets/pill.png";
import { HTTP } from "@/axios";
import { formatNumber, formatPrice, isTelephone, taxNumber } from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_retail_detail",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_not_found: picture_not_found,
      picture_product: picture_product,
      perPage: -1,
      image_modal: false,
      order_number: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'quantity',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_header: [],
      slip_img: [],
      tax_invoice_show: false,
      data_tax_invoice: {
        name: null,
        delivery_address: null,
        tax_number: null,
        branch_code: null,
      },
      preview_modal: false,
      loading_img: false,
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    show_img() {
      this.preview_modal = true
      this.loading_img = true
      this.loading_img = false
    },
    async  get_data() {
      this.loading_page = true
      await HTTP.post('sell/orderdetail', {
        order_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_header = res.data.object.order_head
          if (res.data.object.order_head.total !== null && res.data.object.order_head.total !== 'undefined') {
            this.order_number = res.data.object.order_head.total
          }
          else {
            this.order_number = 0
          }
          this.data_list = res.data.object.order_lists
          if (res.data.object.slips.length > 0) {
            this.slip_img = res.data.object.slips[0]
          }
          else {
            this.slip_img = ''
          }
        }
      })
    },
    confirm_detail() {
      this.$router.push('/sell/confirmorderdetail/' + this.$route.params.id)
    },
    in_correct() {
      this.$router.push('/sell/payincorrect/' + this.$route.params.id)
    },
    print_send_order() {
      if (this.order_header.payment_type !== 3) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelope/' + this.order_header.order_code, '_blank')
      }
      else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpay/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslip/' + this.order_header.order_code, '_blank')
      }
    },
    print_tax_invoice(name, delivery_address) {
      this.data_tax_invoice.name = name
      this.data_tax_invoice.delivery_address = delivery_address
      // window.open('http://192.168.1.161:8000/taxinvoice/' + this.order_header.order_code + '?data=' + this.data_tax_invoice, '_blank')
      this.tax_invoice_show = true;
    },
    tax_invoice_save() {
      let data = {
        customer_name: this.data_tax_invoice.name,
        delivery_address: this.data_tax_invoice.delivery_address,
        tax_number: this.data_tax_invoice.tax_number,
        branch_code: this.data_tax_invoice.branch_code,
      }
      if (this.$refs.tax_invoice_save.validate()) {
        window.open('https://www.pharmacare-plus.com/taxinvoice/' + this.order_header.order_code + '?data=' + JSON.stringify(data), '_blank')
      }
    }
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum + (0)
        }
        else {
          return sum + (total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}

.rounded_card {
  border-radius: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.grid_img {
  display: grid;
  grid-template-columns: 70% 30%;
}

.border_table {
  border: #e0e0e0 solid 1px
}

.mobile_btn {
  width: 50%;
}

.display_pc {
  display: block;
}

.display_mobile {
  display: none;
}

@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_mx {
    margin: auto;
  }

  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_btn {
    width: 100%;
  }

  .display_pc {
    display: none;
  }

  .display_mobile {
    display: block;
  }
}
</style>
